import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { graphql } from "react-apollo";
import compose from "recompose/compose";
import queryString from "query-string";
import { inject, observer } from "mobx-react";
import withDefaultParams from "Services/withDefaultParams";
import useDefaultParams from "Services/useDefaultParams";
import { variablesFromRouter } from "Services/QueryBuilder";
import {
    DECLINATION_QUERY,
    TARIFF_TAGS_QUERY,
    PROVIDERS_WITH_TARIFFS_QUERY_FOR_SEO,
    PROVIDERS_WITH_TARIFFS_PLAN_C_QUERY_FOR_SEO,
    TARIFFS_QUERY_FOR_SEO,
    EXCLUSIVE_TARIFFS_QUERY_V2_FOR_SEO,
    INFO_VARIABLES_TARIFFS_QUERY,
} from "Services/queries";
import { newFormList } from "Constants/Tags";
import {
    SeoTextRatesTags,
    SeoTextProviderRatesTags,
    SeoTextExclusive,
} from "ComponentsUI/SeoText";
import QuestionAnswer from "ComponentsUI/QuestionAnswer";

class SeoTextContainer extends Component {
    render() {
        const {
            match: {
                params: { tagCode },
            },
            siteCode,
            regionQuery,
            tariffsTagsQuery,
            tariffsQuery,
            routeName,
            providerInfo,
            tariffList,
            exclusiveTariffList,
            tariffsInfo,
            faq,
        } = this.props;
        let useTag;

        if (
            !regionQuery ||
            (routeName === "RatesTags" &&
                (!tariffsTagsQuery ||
                    !tariffsQuery ||
                    !tariffsQuery?.pagination?.items_total)) ||
            (routeName === "ProviderRatesTags" &&
                (!tariffsTagsQuery ||
                    !providerInfo ||
                    !tariffList?.data?.length)) ||
            (routeName === "Exclusive" &&
                (!exclusiveTariffList || !exclusiveTariffList?.data.length)) ||
            (routeName === "ProviderDetails" && !tariffsInfo)
        ) {
            return null;
        }

        if (!!tariffsTagsQuery) {
            useTag = tariffsTagsQuery.find(elem => {
                return elem.url == tagCode;
            });
        }

        if (routeName === "RatesTags") {
            return (
                <SeoTextRatesTags
                    region={regionQuery}
                    useTag={useTag}
                    tariffs={tariffsQuery}
                    siteCode={siteCode}
                />
            );
        } else if (routeName === "ProviderRatesTags") {
            return (
                <SeoTextProviderRatesTags
                    region={regionQuery}
                    useTag={useTag}
                    tariffList={tariffList}
                    providerInfo={providerInfo}
                    siteCode={siteCode}
                />
            );
        } else if (routeName === "Exclusive") {
            return (
                <SeoTextExclusive
                    siteCode={siteCode}
                    region={regionQuery}
                    tariffInfo={exclusiveTariffList.info}
                />
            );
        } else if (routeName === "ProviderDetails" && !faq?.length) {
            return (
                <QuestionAnswer
                    siteCode={siteCode}
                    region={regionQuery}
                    providerInfo={providerInfo}
                    tariffsInfo={tariffsInfo}
                />
            );
        } else {
            return null;
        }
    }
}

export default withRouter(
    withDefaultParams(
        variablesFromRouter(
            compose(
                graphql(DECLINATION_QUERY, {
                    skip: props => {
                        const route = props.match.params;
                        const defaultParams = useDefaultParams(route);
                        return !defaultParams.regionUrl;
                    },
                    options: props => {
                        const route = props.match.params;
                        const defaultParams = useDefaultParams(route);
                        return {
                            variables: {
                                filter: `url=${defaultParams.regionUrl}`,
                            },
                        };
                    },
                    props: ({ ownProps, data }) => {
                        if (data.loading) {
                            return { ...ownProps, regionQuery: null };
                        } else {
                            return { ...ownProps, regionQuery: data.region };
                        }
                    },
                }),
                graphql(TARIFF_TAGS_QUERY, {
                    skip: props => {
                        const route = props.match.params;
                        const defaultParams = useDefaultParams(route);
                        return !defaultParams.regionUrl;
                    },
                    options: props => {
                        const route = props.match.params;
                        const defaultParams = useDefaultParams(route);
                        let filter = `region.url=${defaultParams.regionUrl}`;
                        if (props.routeName === "ProviderRatesTags") {
                            filter += `&provider.url_name=${route.providerName}`;
                        }
                        return {
                            variables: {
                                filter,
                                removeId: [1813],
                            },
                        };
                    },
                    props: ({ ownProps, data }) => {
                        if (data.loading) {
                            return { ...ownProps, tariffsTagsQuery: null };
                        } else {
                            return {
                                ...ownProps,
                                tariffsTagsQuery: data.tariffsTags.data,
                            };
                        }
                    },
                }),
                graphql(PROVIDERS_WITH_TARIFFS_QUERY_FOR_SEO, {
                    skip: props => {
                        const {
                            match: {
                                params,
                                params: { tagCode = null },
                            },
                            tariffsTagsQuery,
                            routeName,
                        } = props;
                        const defaultParams = useDefaultParams(params);
                        let newForm = newFormList.includes(tagCode);

                        if (
                            routeName !== "RatesTags" ||
                            newForm ||
                            !tariffsTagsQuery ||
                            !tagCode ||
                            !defaultParams.regionUrl
                        ) {
                            return true;
                        } else {
                            return false;
                        }
                    },
                    options: props => {
                        const {
                            match: {
                                params: { tagCode = null },
                            },
                            tariffsTagsQuery,
                        } = props;
                        let tariffFilter = [];
                        const route = props.match.params;
                        const defaultParams = useDefaultParams(route);

                        let tagInfo = tariffsTagsQuery.find(elem => {
                            return elem.url === tagCode;
                        });
                        if (!!tagInfo) {
                            tariffFilter.push(tagInfo.filter);
                        }
                        tariffFilter.push(
                            `region.url=${defaultParams.regionUrl}`
                        );
                        return {
                            variables: {
                                tariffFilter: tariffFilter.join("&"),
                                providerLimit: 20,
                                providerOffset: 0,
                                tariffsPerProvider: 300,
                                providerJoin: true,
                                vipProvider: true,
                                fillFieldInfo: true,
                            },
                        };
                    },
                    props: ({ ownProps, data }) => {
                        if (data.loading) {
                            return { ...ownProps, tariffsQuery: null };
                        } else {
                            return {
                                ...ownProps,
                                tariffsQuery: data.providersWithTariffs,
                            };
                        }
                    },
                }),
                graphql(PROVIDERS_WITH_TARIFFS_PLAN_C_QUERY_FOR_SEO, {
                    skip: props => {
                        const {
                            match: {
                                params,
                                params: { tagCode = null },
                            },
                            tariffsTagsQuery,
                            routeName,
                        } = props;
                        let newForm = newFormList.includes(tagCode);
                        const defaultParams = useDefaultParams(params);

                        if (
                            routeName !== "RatesTags" ||
                            !newForm ||
                            !tariffsTagsQuery ||
                            !tagCode ||
                            !defaultParams.regionUrl
                        ) {
                            return true;
                        } else {
                            return false;
                        }
                    },
                    options: props => {
                        const {
                            match: {
                                params: { tagCode = null },
                            },
                            tariffsTagsQuery,
                        } = props;
                        let tariffFilter = [];
                        const route = props.match.params;
                        const defaultParams = useDefaultParams(route);

                        let tagInfo = tariffsTagsQuery.find(elem => {
                            return elem.url === tagCode;
                        });
                        if (!!tagInfo) {
                            tariffFilter.push(tagInfo.filter);
                        }
                        tariffFilter.push(
                            `region.url=${defaultParams.regionUrl}`
                        );
                        return {
                            variables: {
                                tariffFilter: tariffFilter.join("&"),
                                providerJoin: true,
                                tariffLimit: 30,
                                tariffOffset: 0,
                                fillFieldInfo: true,
                            },
                        };
                    },
                    props: ({ ownProps, data }) => {
                        if (data.loading) {
                            return { ...ownProps, tariffsQuery: null };
                        } else {
                            return {
                                ...ownProps,
                                tariffsQuery: data.providersWithTariffsPlanC,
                            };
                        }
                    },
                }),
                graphql(TARIFFS_QUERY_FOR_SEO, {
                    skip: props => {
                        let removeId = [1813];
                        let globalId = props?.providerInfo?.global?.id;

                        if (
                            props.routeName === "ProviderRatesTags" &&
                            !removeId.includes(globalId) &&
                            props.tariffsTagsQuery &&
                            (!props.match.params.page ||
                                props.match.params.page == 1)
                        ) {
                            return false;
                        } else {
                            return true;
                        }
                    },
                    options: props => {
                        let filter = props.variables.filter;
                        let params = queryString.parse(props.location.search);
                        if (!!params.district) {
                            filter =
                                filter + `&districts.id=${params.district}`;
                        }
                        let page = 1;
                        if (props.match.params.page) {
                            page = +props.match.params.page;
                        }
                        filter += "&provider.mobile_operator=0";

                        let tagCode = props.match.params.tagCode;
                        if (!!tagCode && props?.tariffsTagsQuery?.length) {
                            const foundTag = props?.tariffsTagsQuery.find(
                                elem => elem.url === tagCode
                            );
                            if (!!foundTag) {
                                filter += `&${foundTag.filter}`;
                            }
                        }
                        return {
                            variables: {
                                ...props.variables,
                                house_id: null,
                                limit: 30,
                                offset: page * 30 - 30,
                                filter: filter,
                                fillFieldInfo: true,
                            },
                        };
                    },
                    props: ({ ownProps, data }) => {
                        if (data.loading) {
                            return { ...ownProps, tariffList: null };
                        } else {
                            return {
                                ...ownProps,
                                tariffList: data?.tariffs,
                            };
                        }
                    },
                }),
                graphql(EXCLUSIVE_TARIFFS_QUERY_V2_FOR_SEO, {
                    skip: props => {
                        let { routeName } = props;
                        return routeName !== "Exclusive";
                    },
                    options: props => {
                        return {
                            variables: {
                                ...props.variables,
                                actualProviderRating: true,
                                fillFieldInfo: true,
                            },
                        };
                    },
                    props: ({ ownProps, data }) => {
                        if (data.loading) {
                            return {
                                ...ownProps,
                                exclusiveTariffList: null,
                            };
                        } else {
                            return {
                                ...ownProps,
                                exclusiveTariffList:
                                    data.tariffsExclusivePageV2,
                            };
                        }
                    },
                }),
                graphql(INFO_VARIABLES_TARIFFS_QUERY, {
                    skip: props => {
                        let { routeName } = props;
                        return routeName !== "ProviderDetails";
                    },
                    options: props => {
                        let {
                            match: {
                                params: { providerName, regionUrl },
                            },
                        } = props;
                        return {
                            variables: {
                                region_url: regionUrl,
                                provider_url: providerName,
                                find_operator: 0,
                                tagType: "provider",
                            },
                        };
                    },
                    props: ({ ownProps, data }) => {
                        if (data.loading) {
                            return {
                                ...ownProps,
                                tariffsInfo: null,
                            };
                        } else {
                            return {
                                ...ownProps,
                                tariffsInfo: data?.infoVariablesTariffs,
                            };
                        }
                    },
                })
            )(SeoTextContainer),
            "order,id"
        )
    )
);
